
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  DocumentsListParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\DocumentsListParameters.ts

export class DocumentsListParameters {

  // int? IntUserId
  public IntUserId?: number=null;

  // string SupplierName
  public SupplierName?: string=null;

  // int[] FamiliesIds
  public FamiliesIds: number[]=[];

  // int? MntFacMin
  public MntFacMin?: number=null;

  // int? MntFacMax
  public MntFacMax?: number=null;

  // int[] DoctypIds
  public DoctypIds: number[]=[];

  // int? LegalFormId
  public LegalFormId?: number=null;

  // int[] PafDocumentIds
  public PafDocumentIds: number[]=[];

  // int[] DocStatutIds
  public DocStatutIds: number[]=[];

  // DateTime? DateExpiDeb
  public DateExpiDeb?: Date=null;

  // DateTime? DateExpiFin
  public DateExpiFin?: Date=null;

  // DateTime? DateDocDeb
  public DateDocDeb?: Date=null;

  // DateTime? DateDocFin
  public DateDocFin?: Date=null;

  // string EtatDossier
  public EtatDossier?: string=null;

  // bool InclureArchive
  public InclureArchive: boolean=false;

  // int? CountryId
  public CountryId?: number=null;
}